import { createContext, useContext } from 'react';

const Context = createContext();

// Allows ourselves to mock the context more readily
export const useAppContext = () => useContext(Context);
export default Context;
